import { render, staticRenderFns } from "./EditLabNote.vue?vue&type=template&id=4daa9536&"
import script from "./EditLabNote.vue?vue&type=script&lang=js&"
export * from "./EditLabNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports